import { FC } from "react";
import StandardModal from "./StandardModal";

interface StandardModalBuscaExternaNfProps {
  showModal: boolean;
  onCloseModal: () => void;
}

const StandardModalBuscaExternaNf: FC<StandardModalBuscaExternaNfProps> = ({ showModal, onCloseModal }) => {
  return (
    <StandardModal
      showModal={showModal}
      scrollable={false}
      onCloseModal={onCloseModal}
      videoSrc="https://www.youtube.com/watch?v=jcemR5XPvGI"
      topBar="O que é a Busca Externa de Notas Fiscais para Condomínios?"
      titulo="📩 O que é a Busca Externa de Notas Fiscais para Condomínios?"
      tituloStyle={{ fontSize: "1vw", fontWeight: "bold", color: "#2F4050", textAlign: "left" }}
      conteudoPrimario=" Nossa inteligência artificial acessa os sistemas das prefeituras e da SEFAZ, rastreando e coletando automaticamente as notas fiscais emitidas para o seu condomínio. Todas as notas encontradas são integradas diretamente ao Group Pay, facilitando a gestão financeira."
      conteudoPrimarioStyle={{ marginBottom: "0.85vh", fontSize: "0.85vw" }}
      conteudoSecundario={
        <>
          <p style={{ fontSize: "0.85vw", lineHeight: "1.2", color: "#2F4050", fontWeight: "bold" }}>
            🔁 Como funciona?
          </p>
          <ol style={{ fontSize: "0.85vw", lineHeight: "1.2", color: "#2F4050", paddingLeft: "2vw", margin: 0 }}>
            <li style={{ marginBottom: "0.5vw" }}>
              Informe os dados de acesso aos sistemas das prefeituras e/ou SEFAZ.
            </li>
            <li style={{ marginBottom: "0.5vw" }}>Anexe o certificado digital A1 para autenticação.</li>
            <li style={{ marginBottom: "0.5vw" }}>
              Após a configuração, o Group Pay buscará e importará todas as notas fiscais emitidas para o condomínio.
            </li>
          </ol>
          <p style={{ fontSize: "0.85vw", lineHeight: "1.2", color: "#2F4050", fontWeight: "bold" }}>
            <strong>Veja no vídeo acima as formas de configurar na prática.</strong>
          </p>
        </>
      }
      size="lg"
      fecharModalAoClicarFora={true}
      containerStyle={{ margin: 0, paddingLeft: "1vw", textAlign: "left" }}
      footer={null}
    />
  );
};

export default StandardModalBuscaExternaNf;
